var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-tabs",
        {
          attrs: { shrink: "", stretch: "", dense: "", align: "left" },
          model: {
            value: _vm.nodeTab,
            callback: function ($$v) {
              _vm.nodeTab = $$v
            },
            expression: "nodeTab",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "q-pl-sm q-pr-sm",
              staticStyle: {
                background: "#B2DFDB",
                color: "#00695C",
                height: "100%",
                display: "flex",
                "align-items": "center",
              },
            },
            [
              _c(
                "b",
                [
                  _c("q-icon", { attrs: { name: "sms", size: "xs" } }),
                  _vm._v(" 노드 "),
                ],
                1
              ),
            ]
          ),
          _vm._l(_vm.tabItems, function (tab, idx) {
            return _c(
              "keep-alive",
              { key: idx },
              [
                _c("q-tab", {
                  attrs: { name: tab.name, label: tab.label },
                  on: {
                    click: function ($event) {
                      return _vm.tabClick(tab)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-list",
              { staticClass: "rounded-borders", attrs: { bordered: "" } },
              [
                _c(
                  "q-expansion-item",
                  {
                    attrs: {
                      dense: "",
                      dark: "",
                      "default-opened": "",
                      icon: "place",
                      "header-class": "bg-blue-grey-6 text-white",
                      "expand-icon-class": "text-white",
                      label: "노드 정보",
                    },
                  },
                  [
                    _c("q-separator"),
                    _c("q-card", { staticClass: "q-pa-sm" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-6 col-sm-6 col-md-3" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "노드번호",
                                value: _vm.node.nodeNo,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-6 col-sm-6 col-md-3" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "노드명",
                                value: _vm.node.nodeTitle,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12 col-md-4" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "검토기간",
                                value:
                                  _vm.node.startStudyDate +
                                  "~" +
                                  _vm.node.endStudyDate,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12 col-md-6" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "노드설명",
                                value: _vm.node.nodeDesc,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12 col-md-6" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "설계조건",
                                value: _vm.node.designConditions,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12 col-md-6" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "작동조건",
                                value: _vm.node.operatingConditions,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12 col-md-6" },
                          [
                            _c("c-label-text", {
                              attrs: {
                                title: "설계의도",
                                value: _vm.node.designIntent,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "시나리오 목록",
            columns: _vm.grid.columns,
            gridHeight: _vm.grid.height,
            data: _vm.node.hazopScenarios,
            merge: _vm.grid.merge,
            filtering: false,
            columnSetting: false,
            usePaging: false,
            editable: _vm.editable && !_vm.disabled,
            selection: "multiple",
            rowKey: "ramHazopAssessScenarioId",
          },
          on: {
            callbackProxy: _vm.callbackProxy,
            innerBtnClicked: _vm.innerBtnClicked,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  props.row["sopImprovementIds"] && props.row["ibmStepNames"]
                    ? _vm._l(
                        _vm.chipDatas(
                          props.row["sopImprovementIds"],
                          props.row["ibmStepNames"]
                        ),
                        function (item, index) {
                          return _c(
                            "q-chip",
                            {
                              key: index,
                              staticStyle: {
                                "margin-bottom": "4px !important",
                              },
                              attrs: {
                                color: item.color,
                                clickable: true,
                                "text-color": "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.linkClick(item, props.row)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.title) + " ")]
                          )
                        }
                      )
                    : void 0,
                  _vm.editable &&
                  Boolean(props.row.ramHazopAssessScenarioId) &&
                  props.row.editFlag !== "C" &&
                  !_vm.disabled
                    ? _c(
                        "div",
                        [
                          _c(
                            "q-btn-group",
                            {
                              staticClass: "ColumInnerBtnGroup",
                              attrs: { outline: "" },
                            },
                            [
                              _c(
                                "q-btn",
                                {
                                  staticClass: "ColumInnerBtn",
                                  attrs: {
                                    icon: "add",
                                    color: "red-6",
                                    "text-color": "white",
                                    align: "center",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.innerBtnClicked(col, props)
                                    },
                                  },
                                },
                                [_c("q-tooltip", [_vm._v(" 개선요청등록 ")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: { label: "이탈추가", icon: "add" },
                        on: { btnClicked: _vm.addRiskType },
                      })
                    : _vm._e(),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.node.hazopScenarios,
                          mappingType: "PUT",
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveScenario,
                          btnCallback: _vm.saveScenarioCallback,
                        },
                      })
                    : _vm._e(),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: { label: "삭제", icon: "remove" },
                        on: { btnClicked: _vm.removeScenario },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }